module.exports = __webpack_public_path__ + "img/2_newModelWorker_gxc.371f9832.png";